import React from 'react'
import LinkAccordian from './LinkAccordian'
import styles from './LinksSection.module.css'

function LinksSection() {
    return (
        <div className={styles.component} id="important-links">
            <div className={styles.componentCover}>
                <h1>Important Links</h1>
                <LinkAccordian/>
            </div>
        </div>
    )
}

export default LinksSection
